import React, { Component } from 'react'
import styled from 'styled-components'

import FilterBox from 'components/FilterBox'
import { Row } from 'react-flexbox-grid'

import EletricidadeGasIcon from 'components/Svg/eg.component.svg'
import EletricidadeIcon from 'components/Svg/electricity.component.svg'
import GasIcon from 'components/Svg/gas.component.svg'
import { Select } from '@ubiwherenpm/adene-ui-components'

import Logic from './logic'

@Logic
export default class Filters extends Component {
  /**
   * Select the icon by the offer type slug
   * @param slug <string>
   */
  getIconBySlug (slug) {
    switch (slug) {
      case 'e':
        return <EletricidadeIcon />
      case 'g':
        return <GasIcon />
      case 'eg':
        return <EletricidadeGasIcon />

      default:
        return <EletricidadeGasIcon />
    }
  }

  render () {
    const { filters, current, options, isCompany, selectedTension, selectedPressure } = this.props
    const { filter, setPressureOption, setTensionOption } = this.actions
    let opts = options.tension
    let setOption = setTensionOption
    let selected = selectedTension

    if (current && current.id === 3) {
      opts = options.pressure
      selected = selectedPressure
      setOption = setPressureOption
    }

    return (
      <Wrapper>
        <Row center={`xs`}>
          {filters && filters.map(({ name, id, slug }) =>
            <FilterBox
              key={`flbox-${id}`}
              name={name}
              icon={this.getIconBySlug(slug)}
              selected={current && current.id === id}
              onClick={() => filter({ id, slug })}
            />
        )}
        </Row>

        { isCompany &&
        <Row>
          <Separator />
          <Column>
            <BorderSelect
              placeholder={'Selecione uma opção'}
              items={opts}
              onChange={(opt) => setOption(opt)}
              selected={selected && selected}
            />
            { current && current.id === 2 &&
              <Title>Tipo de Tensão</Title> }
            { current && current.id === 3 &&
              <Title>Tipo de Pressão</Title> }
            { current && current.id === 1 &&
              <Title>Tipo de Tensão</Title> }
          </Column>

          { current && current.id === 1 &&
          <Column>
            <BorderSelect
              placeholder={'Selecione uma opção'}
              items={options.pressure}
              onChange={(opt) => setPressureOption(opt)}
              selected={selectedPressure && selectedPressure}
            />
            <Title>Tipo de Pressão</Title>
          </Column>
          }
        </Row>
        }
      </Wrapper>

    )
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 825px) {
    width: 100%;
  }
`

const Column = styled.div`
  display:flex;
  flex-direction: column;
  margin-right: 20px;

  @media (max-width: 960px){
    margin: 10px auto;
  }
`

const Separator = styled.div`
  border-left: 1px solid #eee;
  height: 80px;
  margin: 0px 30px;

  @media (max-width: 960px){
    display:none;
  }

`

const BorderSelect = styled(Select)`
  text-align: center;
  & > div:first-child {
    min-width: 150px;
    padding: 20px 20px;
    border-radius: 10px
  }
  margin: 0px 5px;

  > div:last-child {
    > div {
      position: absolute;
    }
  }

`

const Title = styled.div`
  display: block;
  text-transform: uppercase;
  margin-top: 20px;
  font-size: 12px;
  line-height: 12px;
  color: #010101;
  font-weight: bold;
  text-align: center;
  font-family: 'Nunito','Helvetica Neue',sans-serif;
`



// WEBPACK FOOTER //
// ./src/containers/Filters/index.js